import Repository from './Repository'

const resource = 'tenants'

export default {
  getHistoryAssignments (tenantId, params) {
    return Repository.get(`${resource}/${tenantId}/history-horse-rider`, { params: params })
  },
  getHistoryLesson (tenantId, params) {
    return Repository.get(`${resource}/${tenantId}/horse-level`, { params: params })
  },
  downloadHistoryAssigments (tenantId, params) {
    return Repository.get(`exports/${resource}/${tenantId}/horse-rider/pdf`, {
      responseType: 'blob',
      params: params
    })
  },
  getLessonComparison (tenantId, params) {
    return Repository.get(`${resource}/${tenantId}/lesson-comparison`, { params: params })
  },
  getLevelSummary (tenantId, params) {
    return Repository.get(`${resource}/${tenantId}/horse-level-summary`)
  },
  downloadGeneralResults (tenantId, params) {
    return Repository.get(`exports/${resource}/${tenantId}/general-results/pdf`, {
      responseType: 'blob',
      params: params
    })
  }
}
